import React, { useState, useEffect } from 'react';
import apiUrl from '../Apiurl';
import prodVuoto from '../prodottoVuoto';
import { useAuth0 } from '@auth0/auth0-react';
import stilePulsanti from '../interfaccia/stilePulsanti';


function DatoBooleanModificabileInLinea2({idDocumento, 
  valoreAttuale, testoTrueAttuale, testoFalseAttuale, colTrueAttuale, nomeDato, setProductFunction}) {

    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    let classiTastoVerde = "f6 f5-l button-reset fl pv3 tc bn bg-animate tastoVerde hover-bg-black white pointer br2-ns br--right-ns"
    let classiTastoRosso = "f6 f5-l button-reset fl pv3 tc bn bg-animate tastoArancio hover-bg-black white pointer br2-ns br--right-ns"
    let colAttuale;
    let colAttualeContrario;
    let valoreAttualeContrario;
    let testoAttuale;
    let testoContrario;
    const reqUrlSenzaBool = apiUrl+"/prodotti/patchBool/"+idDocumento+"/"+nomeDato+"/"

    if (colTrueAttuale === "verde" && valoreAttuale === "1") {
      colAttuale = classiTastoVerde;
      colAttualeContrario = classiTastoRosso;
    } else if (colTrueAttuale === "rosso" && valoreAttuale === "1") {
      colAttuale = classiTastoRosso
      colAttualeContrario = classiTastoVerde;
    } else if (colTrueAttuale === "verde" && valoreAttuale === "0") {
      colAttuale = classiTastoRosso
      colAttualeContrario = classiTastoVerde;
    } else if (colTrueAttuale === "rosso" && valoreAttuale === "0") {
      colAttuale = classiTastoVerde
      colAttualeContrario = classiTastoRosso;
    }

    if (valoreAttuale === "1") {
      valoreAttualeContrario = "0"
      testoAttuale = testoTrueAttuale;
      testoContrario = testoFalseAttuale;
    } else if (valoreAttuale === "0") {
      valoreAttualeContrario = "1"
      testoAttuale = testoFalseAttuale
      testoContrario = testoTrueAttuale;
    }

    const [classeTasto, setClasseTasto] = useState(colAttuale);
    const [testo, setTesto] = useState(testoAttuale);
    
    
    useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);
   
    

    function patchDatoFunction(e) {
        fetch(reqUrlSenzaBool+valoreAttualeContrario, {method: 'PATCH', headers: {'Authorization': 'Bearer '+token}} )
        .then(resp => resp.json())
        .then(data => setProductFunction(data[0] || prodVuoto))
        .then(e.preventDefault())     
        setClasseTasto(colAttualeContrario);
        setTesto(testoContrario)
    }

    return(
            
        <button
            type="button"
            className={classeTasto+' datoModificabileInLineaTasto w-100'}
            onClick={patchDatoFunction}
        >{/* valoreAttuale == "1" ? testoTrueAttuale : testoFalseAttuale */}{testo}</button>
    )
    
}


export default DatoBooleanModificabileInLinea2;



